// Sample data for visualizations
export const demographicsData = [
    { name: 'Men', value: 65 },
    { name: 'Women', value: 33 },
    { name: 'Non-binary', value: 2 },
  ];
    
  export const ageData = [
    { name: '18-25', value: 45 },
    { name: '26-35', value: 32 },
    { name: '36-45', value: 18 },
    { name: '46+', value: 5 },
  ];
  
  export const countryData = [
    { name: 'Cameroon', value: 15 },
    { name: 'Nigeria', value: 22 },
    { name: 'Philippines', value: 18 },
    { name: 'Kenya', value: 12 },
    { name: 'India', value: 8 },
    { name: 'Ghana', value: 6 },
    { name: 'Indonesia', value: 5 },
    { name: 'Others', value: 14 },
  ];
    
  export const recruitmentData = [
    { name: 'Employment agency', value: 38 },
    { name: 'Friends', value: 27 },
    { name: 'Social media', value: 22 },
    { name: 'Family', value: 7 },
    { name: 'Travel agency', value: 4 },
    { name: 'Other', value: 2 },
  ];
    
  export const socialMediaData = [
    { name: 'WhatsApp', value: 35 },
    { name: 'Facebook', value: 28 },
    { name: 'WeChat', value: 15 },
    { name: 'Telegram', value: 12 },
    { name: 'TikTok', value: 7 },
    { name: 'Other', value: 3 },
  ];
    
  export const promisedJobsData = [
    { name: 'Teaching', value: 30 },
    { name: 'Customer service', value: 25 },
    { name: 'Marketing', value: 20 },
    { name: 'IT/Programming', value: 15 },
    { name: 'Administration', value: 7 },
    { name: 'Other', value: 3 },
  ];
    
  export const travelDocumentsData = [
    { 
      name: 'Used own passport', 
      yes: 85, 
      no: 15 
    },
    { 
      name: 'Received visa from recruiter', 
      yes: 62, 
      no: 38 
    },
    { 
      name: 'Received work permit from recruiter', 
      yes: 40, 
      no: 60 
    },
    { 
      name: 'Used someone else\'s documents', 
      yes: 8, 
      no: 92 
    },
  ];
    
  export const controlData = [
    { name: 'Denied freedom of movement', value: 95 },
    { name: 'Constant surveillance', value: 92 },
    { name: 'Withholding of wage', value: 88 },
    { name: 'False promise/deception', value: 85 },
    { name: 'Psychological abuse', value: 78 },
    { name: 'Debt bondage/ransom', value: 70 },
    { name: 'Physical abuse', value: 65 },
    { name: 'Threats to individual/family', value: 60 },
    { name: 'Withholding of documents', value: 45 },
    { name: 'Denied food/drink', value: 25 },
    { name: 'Denied medical treatment', value: 20 },
    { name: 'Sexual abuse/violence', value: 15 },
    { name: 'Drugs/alcohol administration', value: 10 },
  ];
    
  export const scamTypesData3 = [
    { subject: 'Cryptocurrency', A: 80 },
    { subject: 'Gaming/Gambling', A: 65 },
    { subject: 'Dating/Romance', A: 55 },
    { subject: 'Impersonation', A: 50 },
    { subject: 'E-commerce', A: 45 },
    { subject: 'Pyramid schemes', A: 40 },
    { subject: 'Loan schemes', A: 35 },
  ];

  export const scamTypesData = [
    { name: 'Cryptocurrency', value: 42 },
    { name: 'Dating/Romance', value: 23 },
    { name: 'Gaming/Gambling', value: 15 },
    { subject: 'Impersonation', value: 50 },
    { name: 'E-commerce', value: 10 },
    { subject: 'Pyramid schemes', value: 40 },
    { subject: 'Loan schemes', value: 35 },
  ];
    
  export const targetCountriesData = [
    { name: 'United States', value: 48 },
    { name: 'United Kingdom', value: 35 },
    { name: 'Australia', value: 28 },
    { name: 'Canada', value: 25 },
    { name: 'Germany', value: 18 },
    { name: 'France', value: 15 },
    { name: 'Japan', value: 12 },
    { name: 'Other', value: 19 },
  ];
    
  export const monthlyData = [
    { name: 'Jan', count: 12 },
    { name: 'Feb', count: 19 },
    { name: 'Mar', count: 25 },
    { name: 'Apr', count: 31 },
    { name: 'May', count: 24 },
    { name: 'Jun', count: 15 },
    { name: 'Jul', count: 20 },
    { name: 'Aug', count: 28 },
    { name: 'Sep', count: 30 },
    { name: 'Oct', count: 35 },
    { name: 'Nov', count: 40 },
    { name: 'Dec', count: 38 },
  ];
  
  export const educationData = [
    { name: 'Primary education', value: 15 },
    { name: 'Secondary education', value: 45 },
    { name: 'Vocational training', value: 20 },
    { name: 'Bachelor\'s degree', value: 15 },
    { name: 'Master\'s degree', value: 4 },
    { name: 'No formal education', value: 1 },
  ];
  
  export const debtBondageData = [
    { name: 'None', value: 30 },
    { name: '$0-$1,000', value: 5 },
    { name: '$1,001-$3,000', value: 45 },
    { name: '$3,001-$5,000', value: 15 },
    { name: '$5,000+', value: 5 },
  ];
  
  export const languagesData = [
    { name: 'English', value: 65 },
    { name: 'Mandarin', value: 15 },
    { name: 'Spanish', value: 8 },
    { name: 'French', value: 6 },
    { name: 'German', value: 4 },
    { name: 'Other', value: 2 },
  ];
  
  export const referralSourceData = [
    { name: 'NGO', value: 45 },
    { name: 'Embassy', value: 25 },
    { name: 'Hotline', value: 15 },
    { name: 'Family', value: 8 },
    { name: 'Self-referral', value: 5 },
    { name: 'Other', value: 2 },
  ];
  
  export const assistanceTypesData = [
    { name: 'Shelter', value: 85 },
    { name: 'Legal assistance', value: 75 },
    { name: 'Medical care', value: 65 },
    { name: 'Psychosocial support', value: 62 },
    { name: 'Return assistance', value: 58 },
    { name: 'Reintegration support', value: 45 },
  ];
  
  export const caseStatusData = [
    { name: 'Pending', value: 38, percent: 12 },
    { name: 'In Process', value: 74, percent: 23 },
    { name: 'Assisted', value: 205, percent: 65 },
  ];
  
  export const recentCasesData = [
    {
      id: 'MM10250011',
      age: 38,
      gender: 'Man',
      origin: 'Cameroon',
      scamType: 'Cryptocurrency',
      status: 'Assisted',
    },
    {
      id: 'MM10250010',
      age: 26,
      gender: 'Woman',
      origin: 'Philippines',
      scamType: 'Dating',
      status: 'Assisted',
    },
    {
      id: 'MM10250009',
      age: 31,
      gender: 'Man',
      origin: 'Nigeria',
      scamType: 'Gaming',
      status: 'In process',
    },
    {
      id: 'MM10250008',
      age: 24,
      gender: 'Man',
      origin: 'Kenya',
      scamType: 'E-commerce',
      status: 'Pending',
    },
    {
      id: 'MM10250007',
      age: 29,
      gender: 'Woman',
      origin: 'Ghana',
      scamType: 'Cryptocurrency',
      status: 'Assisted',
    },
  ];
  
  export const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d'];

  export const recruitmentTransportLocations_before = [
    {
      id: 1,
      name: "Main Recruitment Center",
      description: "Primary recruitment and processing center",
      coordinates: [16.8661, 96.1951], // Yangon coordinates
      type: "center"
    },
    {
      id: 2,
      name: "Northern Transport Hub",
      description: "Transport hub for northern region operations",
      coordinates: [22.0353, 96.4567], // Mandalay coordinates
      type: "hub"
    },
    {
      id: 3,
      name: "Eastern Processing Center",
      description: "Processing center for eastern border operations",
      coordinates: [16.7739, 98.2035], // Myawaddy coordinates
      type: "center"
    },
    {
      id: 4,
      name: "Southern Transport Hub",
      description: "Major transport hub for southern operations",
      coordinates: [16.7808, 96.1497], // Yangon port coordinates
      type: "hub"
    },
    {
      id: 5,
      name: "Western Border Point",
      description: "Border crossing point for western operations",
      coordinates: [20.1462, 92.8984], // Sittwe coordinates
      type: "border"
    }
  ];

  // Recruitment and transportation locations data
export const recruitmentTransportLocations = [
  {
    id: 1,
    name: "Bangkok, Thailand",
    coordinates: [13.7563, 100.5018],
    type: "Recruitment Hub",
    description: "Major recruitment center in Southeast Asia"
  },
  {
    id: 2,
    name: "Mae Sot, Thailand",
    coordinates: [16.7157, 98.5706],
    type: "Transit Point",
    description: "Border town used for crossing into Myanmar"
  },
  {
    id: 3,
    name: "Myawaddy, Myanmar",
    coordinates: [16.6867, 98.5089],
    type: "Destination",
    description: "Location of several scam compounds"
  },
  {
    id: 4,
    name: "Nairobi, Kenya",
    coordinates: [-1.2921, 36.8219],
    type: "Recruitment Hub",
    description: "Major recruitment point in East Africa"
  },
  {
    id: 5,
    name: "Lagos, Nigeria",
    coordinates: [6.5244, 3.3792],
    type: "Recruitment Hub",
    description: "Major recruitment point in West Africa"
  },
  {
    id: 6,
    name: "Manila, Philippines",
    coordinates: [14.5995, 120.9842],
    type: "Recruitment Hub",
    description: "Major recruitment center in Southeast Asia"
  },
  {
    id: 7,
    name: "Phnom Penh, Cambodia",
    coordinates: [11.5564, 104.9282],
    type: "Destination",
    description: "Location of multiple scam compounds"
  },
  {
    id: 8,
    name: "Dubai, UAE",
    coordinates: [25.2048, 55.2708],
    type: "Transit Point",
    description: "Common transit point for victims from Africa and South Asia"
  }
];